export const DASHBOARD_MENU_KEY = "dashboard";
export const JOBS_MENU_KEY = "jobs";
export const APPLICATIONS_MENU_KEY = "applications";
export const MATCH_CANDIDATES_MENU_KEY = "match-candidates";
export const AI_CANDIDATES_MENU_KEY = "ai-candidates";
export const EMPLOYEES_MENU_KEY = "employees";
export const SHORTLISTED_MENU_KEY = "shortlisted";
export const INVITED_MENU_KEY = "invited";

export type SidebarMenuKey =
	| typeof DASHBOARD_MENU_KEY
	| typeof JOBS_MENU_KEY
	| typeof APPLICATIONS_MENU_KEY
	| typeof MATCH_CANDIDATES_MENU_KEY
	| typeof AI_CANDIDATES_MENU_KEY
	| typeof EMPLOYEES_MENU_KEY
	| typeof SHORTLISTED_MENU_KEY
	| typeof INVITED_MENU_KEY;
